import { addCoreAgentConversationTitlesSyncSlice } from './add';
import { combineReducers } from 'redux';
import { defaultAgentConversationTitlesState } from './state';
import { joinSyncReducers } from '@sonar-software/xuder';
import { updateCoreAgentConversationTitleSyncSlice } from './update';

export const coreAgentConversationTitlesReducers = combineReducers({
	read: joinSyncReducers(
		[
			addCoreAgentConversationTitlesSyncSlice.syncReducer,
			updateCoreAgentConversationTitleSyncSlice.syncReducer
		],
		defaultAgentConversationTitlesState
	)
});
